module.exports = __webpack_public_path__ + "static/img/icon-phone.0f6e6f05.png";